const CSV_SPECIAL_CHARS = /[",\r\n]/

function escapeCSVCell(value: string) {
  return CSV_SPECIAL_CHARS.test(value) ? `"${value.replace(/"/g, '""')}"` : value
}

/**
 * Serialize rows of cells into an RFC 4180 CSV string. Cells containing a comma, a double quote
 * or a line break are wrapped in double quotes, with inner quotes doubled.
 */
export function toCSV(rows: string[][]): string {
  return rows.map(row => row.map(escapeCSVCell).join(',')).join('\r\n')
}

export function downloadCSV(content: string, filename: string) {
  const blob = new Blob([content], { type: 'text/csv' })
  const a = document.createElement('a')
  a.href = URL.createObjectURL(blob)
  a.download = filename
  // Append the anchor to the body (required for Firefox)
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
